/** Modula 1 has drawers 1001..1020; the export only lists the ones with compartments. */
export const MODULA_1_DRAWERS = Array.from({ length: 20 }, (_, i) => 1001 + i);
//# sourceMappingURL=types.js.map